'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _Button = require('./Button.style');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Generic button component. Used as the base for other buttons.
 *  You will most likely never use this component directly because
 *  it is mostly unstyled. But you could... See below for stylaized
 *  Button components.
 */
var Button = function Button(_ref) {
  var children = _ref.children,
      className = _ref.className,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      href = _ref.href,
      tooltip = _ref.tooltip,
      tooltipDelayShow = _ref.tooltipDelayShow,
      type = _ref.type,
      rest = (0, _objectWithoutProperties3.default)(_ref, ['children', 'className', 'disabled', 'onClick', 'href', 'tooltip', 'tooltipDelayShow', 'type']);

  if (href) {
    return _react2.default.createElement(
      'a',
      (0, _extends3.default)({
        href: !disabled ? href : null,
        onClick: onClick,
        className: className,
        disabled: disabled,
        'data-tip': tooltip
      }, rest),
      _react2.default.createElement(
        'div',
        { className: 'anchor' },
        _react2.default.createElement(
          'div',
          { className: 'inner' },
          children,
          tooltip && _react2.default.createElement(_reactTooltip2.default, { delayShow: tooltipDelayShow })
        )
      )
    );
  }

  return _react2.default.createElement(
    'button',
    (0, _extends3.default)({
      onClick: onClick,
      type: type || 'button',
      className: className,
      disabled: disabled,
      'data-tip': tooltip
    }, rest),
    _react2.default.createElement(
      'div',
      { className: 'inner' },
      children,
      tooltip && _react2.default.createElement(_reactTooltip2.default, { delayShow: tooltipDelayShow })
    )
  );
};

exports.Button = Button;
Button.propTypes = {
  /**
   * Child components to display in this button
   */
  children: _propTypes2.default.node,
  /**
   * Whether this button is disabled or not. Disabling will also disable onClick.
   */
  disabled: _propTypes2.default.bool,
  /**
   * Action to perform on button click.
   */
  onClick: _propTypes2.default.func,
  /**
   * This property is required to apply glamorous styles to the component.
   * It is not necessary to add a className, but it will be merged with the
   * glamorous className if you do.
   */
  className: _propTypes2.default.string.isRequired,
  /**
   * if supplied, makes the button a link to this url. This will trigger a change
   * from `<button>` to `<a>`, so be careful not to pass href with anything that
   * shouldn't land on an `<a>` , since that will be pass as {...rest}
   */
  href: _propTypes2.default.string,
  /**
   * Tooltip to be displayed when hovering over the button.
   */
  tooltip: _propTypes2.default.string,
  /**
   * The delay in milliseconds before showing the tooltip.
   */
  tooltipDelayShow: _propTypes2.default.number,
  /**
   * HTML button type (e.g. 'submit').
   */
  type: _propTypes2.default.string

};
Button.defaultProps = {
  disabled: false,
  tooltipDelayShow: 750
};

exports.default = (0, _glamorous2.default)(Button)(_Button.defaultStyle, _Button.mapPropsAndThemeToStyle);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/buttons/Button/Button.js
// module id = 94
// module chunks = 0